<template>
    <FieldItem
        :id="id"
        :label="$t(fieldConfig.label)"
    >
        <div class="search-summary__block">
            <div
                v-for="t in DATABASE_TYPES"
                :key="t"
                class="search-summary__option"
            >
                <label>
                    <input
                        v-if="multiple"
                        v-model="fieldValue"
                        :value="t"
                        :disabled="fieldValue.length === 1 && fieldValue[0] === t"
                        type="checkbox"
                        @change="syncChange"
                    >
                    <input
                        v-else
                        v-model="singleDbType"
                        :value="t"
                        type="radio"
                        @change="syncChange"
                    >
                    <span>{{ $t(`Search.btns.${t.toLowerCase()}`) }}</span>
                </label>
            </div>
        </div>
    </FieldItem>
</template>

<script>
import FieldItem from '../components/FieldItem.vue';
import { FieldItemMixin } from './mixins';
import { DATABASE_TYPES } from '../constants/index';

export default {
    components: {
        FieldItem,
    },
    mixins: [FieldItemMixin],
    inject: ['store'],
    props: {
        fieldName: {
            type: String,
            default: 'dbType',
        },
        multiple: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            DATABASE_TYPES,
        };
    },
    computed: {
        singleDbType: {
            get() {
                return this.fieldValue[0] || undefined;
            },
            set(val) {
                this.fieldValue = val ? [val] : [];
            },
        },
    },
};
</script>
